import { useMutation, useQueryClient } from '@tanstack/react-query';
import { voucherRedeem as voucherRedeemApi } from '@/services/apiVoucherRedeem';
import toast from 'react-hot-toast';

export function useVoucherRedeem() {
    const queryClient = useQueryClient();
    const {
        mutate: voucherRedeem,
        isPending,
        error,
    } = useMutation({
        mutationFn: voucherRedeemApi,
        onSuccess: () => {
            toast.success('تم شراء المحاضرات بنجاح');

            queryClient.invalidateQueries({ active: true });
        },

        onError: (err) => {
            if (
                err.response.status == 422 &&
                err.message == 'The voucher code was already redeemed.'
            ) {
                toast.error('الرجاء اختيار محاضرة.');
            } else {
                toast.error('الكود غير صحيح');
            }
        },
    });

    return { voucherRedeem, isPending, error };
}
